import getMatchingVariant from '../utils/variants/getMatchingVariant';
import updatePrice from '../utils/variants/updatePrice';
import updateSelectedVariant from '../utils/variants/updateSelectedVariants';
import updateFormControls from '../utils/variants/updateFormControls';
import updateURL from '../utils/variants/updateURL';
import preselectVariantFromURL from '../utils/variants/preselectVariantFromURL';
import updateStockIndicator from '../utils/variants/updateStockIndicator';

const initProductVariants = (container = document.querySelector('[data-product-main]')) => {
  if (!container) return;
  const variantEls = container.querySelectorAll('[data-variant-input]');
  const sellingPlanEls = container.querySelectorAll('[data-selling-plan-radio]');
  if (!variantEls.length && !sellingPlanEls.length) return;

  const form = container.querySelector('[data-product-form]');
  if (!form) return;

  const variantsDataEl = form.querySelector('[data-product-variants-json]');
  const optionNamesEl = form.querySelector('[data-product-options-json]');
  const variantInventoryEl = form.querySelector('[data-product-variants-inventory-policy-json]');
  const variantIdInput = form.querySelector('[data-atc-id-input]');
  const sellingPlanGroupContainerEl = form.querySelector('[data-selling-plan-groups]');
  const sellingPlanIdInput = sellingPlanGroupContainerEl?.querySelector('[data-selling-plan-input]');
  const sellingPlanInfoEls = sellingPlanGroupContainerEl?.querySelectorAll('[data-selling-plan-info]');
  const quantitySelector = form.querySelector('[data-quantity-selector]');
  const quantityInput = quantitySelector?.querySelector('[data-quantity-input]');
  const atcButton = form.querySelector('button[type="submit"]');
  const atcButtonPrice = atcButton?.querySelector('[data-atc-price]');
  const atcButtonMsg = atcButton?.querySelector('[data-atc-price-msg]');
  const productControls = container.querySelector('[data-product-controls]');
  const optionValueElement = form.querySelector('[data-option-value]');
  const stockIndicator = container.querySelector('[data-stock-indicator]');

  let variantsData = [];
  let optionNames = [];
  let variantInventory = [];

  try {
    variantsData = JSON.parse(variantsDataEl?.textContent || '[]');
    optionNames = JSON.parse(optionNamesEl?.textContent || '[]');
    variantInventory = JSON.parse(variantInventoryEl?.textContent || '[]');
  } catch (e) {
    console.error('Invalid variant/options JSON', e);
    return;
  }

  const selectedOptions = {};

  const priceContainer = document.querySelector('[data-product-price-pdp]');
  const priceEl = priceContainer?.querySelector('[data-product-price]');
  const compareAtPriceEl = priceContainer?.querySelector('[data-product-compare-at-price]');
  const badgeEl = priceContainer?.querySelector('[data-product-sale-badge]');

  const updateVariantDetails = (variantStock) => {
    const variant = getMatchingVariant(selectedOptions, variantsData, optionNames);
    if (!variant) return;

    variantIdInput && (variantIdInput.value = variant.id);
    updatePrice({
      priceEl,
      compareAtPriceEl,
      badgeEl,
      price: variant.price,
      compareAtPrice: variant.compare_at_price,
      badgeTemplate: window.theme.strings.priceBadgeText
    });

    updateSelectedVariant({
      variant,
      variantInventory,
      elements: {
        productControls,
        atcButtonMsg,
        optionValueElement,
        stockIndicator
      },
      strings: window.theme.strings
    });

    updateURL({ variantID: variant.id, sellingPlanIdInput });

    updateFormControls({
      variant,
      qty: +quantityInput.value,
      variantsData,
      optionNames,
      selectedOptions,
      atcButton,
      atcButtonPrice,
      quantitySelector
    });

    quantitySelector.dataset.maxQuantity = variantStock;
  };

  const updateSelectedOption = (name, value, variantStock) => {
    selectedOptions[name] = value;
    updateVariantDetails(variantStock);
  };

  if (variantEls.length) {
    variantEls.forEach(variant => {
      variant.addEventListener('change', ({ target }) => {
        target.setAttribute('data-active-variant', '');
        variantEls.forEach(variant => {
          if (variant !== target) {
            variant.removeAttribute('data-active-variant');
          }
        });
        const variantStock = target.getAttribute('data-max-quantity');
        if (stockIndicator) {
          updateStockIndicator(
            stockIndicator,
            variantStock
          );
        }
        const { name, value } = target;
        updateSelectedOption(name, value, variantStock);
      });
    });
  }

  preselectVariantFromURL({
    variantsData,
    optionNames,
    form,
    selectedOptions,
    sellingPlanInfoEls,
    sellingPlanIdInput,
    updateSelectedOption,
    updateVariantDetails
  });
};

export default initProductVariants;
